/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { ReactComponent as MenuIcon } from '../../../resources/images/menu-sandwich.svg';
import { ReactComponent as MenuCloseIcon } from '../../../resources/images/mobile-navigation-close.svg';

/* Components */
/* Styles */
import styles from "./styles.js"


const ToggleMenu = ({handleToggleMenu, isMobileNavOpen}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div
      className={ `${classes.toggleMenu}` }
      onClick={ handleToggleMenu }
    >
      { isMobileNavOpen ? <MenuCloseIcon /> : <MenuIcon />}
    </div>
  )
}

export default ToggleMenu;
